<template>
    <span class="eda-link" @click="$emit('click')">
        <template v-if="to.length">
        <router-link
                class="eda-link__link"
                :to="to">
            <slot></slot>
        </router-link>
        </template>

        <template v-else-if="href.length">
        <a
                class="eda-link__link"
                :href="href"
                :target="target"
        >
            <slot></slot>
        </a>
        </template>

        <template v-else>
             <a class="eda-link__link"> <slot></slot> </a>
        </template>
    </span>


</template>

<script>
    export default {
        name: "eda-link",
        props: {
            to: {type: String, default: ""},
            target: {type: String, default: null},
            href: {type: String, default: ""}
        }
    }
</script>

<style>
    .eda-link__link {
        cursor: pointer;
        text-decoration: none;
        color: #00B27C;
    }


</style>